export default __webpack_public_path__ + "static/media/diagram-es.abaf1540.webp";